import { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { formatAddress } from "../../../utils";
import TableWithoutPagination from "../../Table/TableWithoutPagination";

class CustomerInfosTab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			columns: [
				{
					Header: "Contacts",
					columns: [
						{
							Header: "Nom",
							Cell: ({ row }) => {
                                let contactName = this.props.customer.contacts.length > 0 ? this.props.customer.contacts[row.index].name : "";

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                                        {contactName}
                                    </div>
                                );
							},
						},
						{
							Header: "Coordonnées",
							Cell: ({ row }) => {
                                let contact = this.props.customer.contacts.length > 0 ? this.props.customer.contacts[row.index] : null;

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                                        {contact ? contact.email : ""}
                                        {(contact && contact.phone && contact.email) ? (<br />) : null}
                                        {contact ? contact.phone : ""}
                                    </div>
                                );
							},
						},
					],
				},
			],
		};
	}

	render() {
		return (
			<Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
				<CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
					<div className="row div-center">
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id="customer-code"
								label="Code"
								className="full_size light-disabled"
								value={this.props.customer.customer_code}
							/>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id="name"
								label="Nom"
								className="full_size light-disabled"
								value={this.props.customer.name}
							/>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id="mail"
								label="Email"
								className="full_size light-disabled"
								value={this.props.customer.email}
							/>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id="phone"
								label="Téléphone"
								className="full_size light-disabled"
								value={this.props.customer.phone}
							/>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id="address"
								label="Adresse"
								multiline
								className="full_size light-disabled"
								value={formatAddress(this.props.customer)}
							/>
						</div>
						<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
							<TableWithoutPagination
								filterable={false}
								data={this.props.customer.contacts}
								columns={this.state.columns}
							/>
						</div>
					</div>
				</CardContent>
			</Card>
		);
	}
}

export default CustomerInfosTab;
